// ABOUTME: Loading spinner component with various sizes
// ABOUTME: Provides centered spinner with screen/full height options

import * as React from "react"
import { cn } from "@shared/lib/utils"
import { SpinnerIcon } from "./SpinnerIcon"
import { sizeClasses, colorClasses, type SpinnerColor, type SpinnerSize } from "./spinnerClasses"

interface CSpinnerProps {
  typeHeight?: "screen" | "full"
  className?: string
  size?: SpinnerSize
  color?: SpinnerColor
}

export const CSpinner: React.FC<CSpinnerProps> = ({
  typeHeight = "screen",
  className,
  size = "xl",
  color = "info",
}) => {
  return (
    <div className={cn("flex justify-center items-center", typeHeight === "screen" ? "h-screen" : "h-full", className)}>
      <span>
        <SpinnerIcon className={cn(sizeClasses[size], colorClasses[color])} />
      </span>
    </div>
  )
}
